module.exports = __webpack_public_path__ + "2ea86c3c10e8900c377f61c4480f9080.woff";